import { render, staticRenderFns } from "./ResourceRequestManagement.vue?vue&type=template&id=a438b5b4"
import script from "./ResourceRequestManagement.vue?vue&type=script&lang=js"
export * from "./ResourceRequestManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports